import { postRequest } from "../api/apiServices";
import { candidatesLeadsList } from "../api/apiList";
import { Candidate } from "./CandidateDashboard";

export interface CampaignLeadsQuery {
  campaignId: string;
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
  searchColumns?: string[];
}

export interface CampaignLeadsPageResult {
  candidates: Candidate[];
  count: number;
  page: number;
  name: string;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

const DEFAULT_SEARCH_COLUMNS = [
  "firstName",
  "lastName",
  "email",
  "jobTitle",
  "phone",
];

export const fetchCampaignLeadsPage = async (
  query: CampaignLeadsQuery
): Promise<CampaignLeadsPageResult | null> => {
  const response: any = await postRequest(candidatesLeadsList, {
    page: query.page ?? 1,
    limit: query.limit ?? 10,
    campaignId: query.campaignId,
    ...(query.status ? { status: query.status } : {}),
    ...(query.search ? { search: query.search } : {}),
    searchColumns: query.searchColumns ?? DEFAULT_SEARCH_COLUMNS,
  });

  const data = response?.data?.data;
  if (!data) return null;

  return {
    candidates: data.candidate || [],
    count: data.count ?? 0,
    page: (data.page ?? 1) - 1,
    name: data.name || "",
    hasNextPage: !!data.hasNextPage,
    hasPreviousPage: !!data.hasPreviousPage,
  };
};

export const fetchAllCampaignLeads = async (
  campaignId: string,
  status?: string,
  search?: string
): Promise<Candidate[]> => {
  const limit = 100;
  let page = 1;
  const allLeads: Candidate[] = [];

  while (true) {
    const result = await fetchCampaignLeadsPage({
      campaignId,
      page,
      limit,
      status,
      search,
    });

    if (!result) break;

    allLeads.push(...result.candidates);

    if (!result.hasNextPage) break;
    page += 1;
  }

  return allLeads;
};
